
window.addEventListener("DOMContentLoaded", function() {
  
    TranslatePaymentStatusLanguage(); // account.liquid

    function TranslatePaymentStatusLanguage() {
      
        var OrderFinancialValues = document.getElementsByClassName('order_financial_value');
        var OrderFulfillmentValues = document.getElementsByClassName('order_fulfillment_value');

        var language = [
            ['pending', '決済処理中'],
            ['paid', '支払い済み'],
            ['voided', 'キャンセル済み'],
            ['unfulfilled', '未発送'],
            ['fulfilled', '発送済み'],
        ];

        for (var i = 0; i < OrderFinancialValues.length; i++) {
            for (var j = 0; j < language.length; j++) {
                if (language[j][0] === OrderFinancialValues[i].textContent) {
                    OrderFinancialValues[i].textContent = language[j][1];
                    break;
                }
            }
        }

        for (var i = 0; i < OrderFulfillmentValues.length; i++) {
            for (var j = 0; j < language.length; j++) {
                if (language[j][0] === OrderFulfillmentValues[i].textContent) {
                    OrderFulfillmentValues[i].textContent = language[j][1];
                    break;
                }
            }
        }
      
    }
  
});


window.addEventListener("DOMContentLoaded", function() {
  
    ChangeSoldoutTagColor(); // product-listing.liquid, product-template.liquid

    function ChangeSoldoutTagColor() {
      
        var SoldoutTag = document.getElementsByClassName('soldout');   // 商品一覧ページのタグ
        var UrikireTag = document.getElementsByClassName('urikire');   // 商品ページ詳細のタグ

        for (var i = 0; i < SoldoutTag.length; i++) {
            if (SoldoutTag[i].innerText == "完売") {
                SoldoutTag[i].style.backgroundColor = 'red';
            }
        }

        for (var i = 0; i < SoldoutTag.length; i++) {
            if (SoldoutTag[i].innerText == "生産中") {
                SoldoutTag[i].style.backgroundColor = 'green';
            }
        }

        for (var i = 0; i < SoldoutTag.length; i++) {
            if (SoldoutTag[i].innerText != "完売" && SoldoutTag[i].innerText != "生産中" ) {
                SoldoutTag[i].style.backgroundColor = '#E6B422';  // 黄色にする
            }
        }

        for (var i = 0; i < UrikireTag.length; i++) {
            if (UrikireTag[i].innerText == "完売") {
                UrikireTag[i].style.backgroundColor = 'red';
            }
        }

        for (var i = 0; i < UrikireTag.length; i++) {
            if (UrikireTag[i].innerText == "生産中") {
                UrikireTag[i].style.backgroundColor = 'green';
            }
        }

        for (var i = 0; i < UrikireTag.length; i++) {
            if (UrikireTag[i].innerText != "完売" && UrikireTag[i].innerText != "生産中" ) {
                UrikireTag[i].style.backgroundColor = '#E6B422';  // 黄色にする
            }
        }
      
    }
  
});


window.addEventListener("DOMContentLoaded", function() {
  
    SortAllItemList(); // navigation.liquid

    function SortAllItemList() {
      
        var CategoryDropdownLink = document.querySelectorAll(".submenu a");
        
        CategoryDropdownLink.forEach(link => {
            if (link.href.includes("collections/all")) {
                link.href += "/?sort_by=created-descending";
            }
        });
      
    }
  
});


document.addEventListener('DOMContentLoaded', function() {
  
    SortAllItemListMobile(); // mobile-navigation.liquid

    function SortAllItemListMobile() {
      
        var CategoryDropdownLink = document.querySelectorAll("#accordion a");
        
        CategoryDropdownLink.forEach(link => {
            if (link.href.includes("collections/all")) {
                link.href += "/?sort_by=created-descending";
            }
        });
      
    }
  
});


window.addEventListener('DOMContentLoaded', function() {
  ChangeTextRefundPolicy();

  function ChangeTextRefundPolicy() {
    // ページ内のすべてのテキストノードを取得
    const treeWalker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    // 各テキストノードに対して置換処理を行う
    while (treeWalker.nextNode()) {
      const node = treeWalker.currentNode;
      if (node.nodeValue.includes('返金ポリシー')) {
        node.nodeValue = node.nodeValue.replace(/返金ポリシー/g, '返品・交換ポリシー');
      }
    }
  }
});

window.addEventListener('DOMContentLoaded', function() {

  HideBackGroundButtonColorInSlider();

  function HideBackGroundButtonColorInSlider() {
  
    const ctaLinks = document.querySelectorAll('.cta a');
    ctaLinks.forEach(link => {
      
      if (link.textContent.trim() === '隠す') {
        
        const captionInners = link.closest('.caption-inners');
        if (captionInners) {
          captionInners.remove();
        }
        
      }
      
    });

  }
  
});


// window.addEventListener("DOMContentLoaded", function() {

//     UndisplayNewItemFromProductList(); // product-listing.liquid

//     function UndisplayNewItemFromProductList() {

      // 商品リストからアイテムを非表示にする
      // if (window.location.href.includes('/collections/')) {
      //     const elements = document.querySelectorAll('[data-alpha="【Alexander】袖フリル付き2WAYシャツ'); // 消したい商品名を入力する
      //     elements.forEach(element => {
      //         element.style.display = "none";
      //     });
      // }

      // // 検索ボックスからアイテムを非表示にする
      // if (window.location.href.includes('/search?')) {
      //   document.querySelectorAll('.product-details h3').forEach(el => {
      //       if (el.textContent.includes('【Alexander】袖フリル付き2WAYシャツ')) { // 消したい商品名を入力する
      //           el.closest('.product-index').style.display = 'none';
      //       }
      //   });
      
//     }

// });


// window.addEventListener('DOMContentLoaded', function() {

//     setTimeout(function() { // 他のアプリよりも後に実行するために0.025秒待機する
//         CloseAddCartButton();  // product-form.liquid
//     }, 25);

//     function CloseAddCartButton() {

//         var now = new Date();
//         var unlock_date = new Date('2024-10-30T21:00:00'); 　// 時刻フォーマット 2024年-00月-00日T00時:00分:00秒 １桁の0を忘れない

//         if (now < unlock_date) { // 現在時刻がアンロックの時間と同じ時刻になった瞬間に開く
      
//           var current_url = window.location.href;
  
//           if (current_url.includes("products/hoo")) {
//               var AddCartButton = document.getElementById('AddToCart');
//               AddCartButton.value = "Coming soon ...";
//               AddCartButton.style.backgroundColor = "gray";
//             　AddCartButton.disabled = true;  // このボタンを押すすべてのイベントを無効化する

//               var CartDrawer = document.getElementById('CartDrawer');
//               CartDrawer.style.visibility = "hidden";
            
//           }

//         }
      
//     }
  
// });


// window.addEventListener('DOMContentLoaded', function() {
  
//     setTimeout(function() {
//         HideComingSoonBadge(); // product-form.liquid
//     }, 1000);

//     function HideComingSoonBadge() {

//         var current_url = window.location.href;

//         if (current_url.includes("products")) {
//             var comingSoonBadges = document.querySelectorAll(".comingSoonBadge2");
            
//             comingSoonBadges.forEach(function(badge) {
//                 badge.style.visibility = "hidden";
//             });
//         }

//     }
  
// });

/* ===== Sticky ATC Bar 20260529===== */
(function() {
  // 商品ページ以外では何もしない
  if (!document.querySelector('.product-template, .product, [data-section-type="product"]')) return;

  // バーのHTML を body に挿入
  var barHTML = '<div id="sticky-atc-bar" class="sticky-atc-bar" aria-hidden="true">'
    + '<div class="sticky-atc-bar__inner">'
    + '<div class="sticky-atc-bar__info">'
    + '<div class="sticky-atc-bar__title" id="sticky-atc-title"></div>'
    + '<div class="sticky-atc-bar__row2">'
    + '<span class="sticky-atc-bar__variant" id="sticky-atc-variant"></span>'
    + '<span class="sticky-atc-bar__price" id="sticky-atc-price"></span>'
    + '</div>'
    + '</div>'
    + '<button id="sticky-atc-btn" class="sticky-atc-bar__btn" type="button">カートに追加</button>'
    + '</div>'
    + '</div>';

  document.body.insertAdjacentHTML('afterbegin', barHTML);

  var bar       = document.getElementById('sticky-atc-bar');
  var stickyBtn = document.getElementById('sticky-atc-btn');
  var titleEl   = document.getElementById('sticky-atc-title');
  var variantEl = document.getElementById('sticky-atc-variant');
  var priceEl   = document.getElementById('sticky-atc-price');

  function getMainBtn() {
    return document.querySelector('[name="add"], .product-form__submit, .btn--add-to-cart, button[data-add-to-cart]');
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' }).format(cents / 100);
  }

  // 初期値をページから取得
  function initBar() {
    // 商品名
    var titleSource = document.querySelector('.product__title, .product-single__title, h1.title, h1');
    if (titleSource && titleEl) titleEl.textContent = titleSource.textContent.trim();

    // 初期バリアント情報はShopifyのグローバル変数から取得
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.selectedVariantId) {
      // variant:changed イベントで更新されるので初期表示は空でもOK
    }

    // メタタグから初期価格取得
    var priceMeta = document.querySelector('meta[property="og:price:amount"]');
    if (priceMeta && priceEl) {
      priceEl.textContent = '¥' + Number(priceMeta.content).toLocaleString('ja-JP');
    }

    // メインボタンの初期状態を反映
    var mainBtn = getMainBtn();
    if (mainBtn && stickyBtn) {
      stickyBtn.disabled = mainBtn.disabled;
      if (mainBtn.disabled) stickyBtn.textContent = '売り切れ';
    }
  }

  // スクロール監視
  function onScroll() {
    var mainBtn = getMainBtn();
    if (!mainBtn) return;
    var rect = mainBtn.getBoundingClientRect();
    var isHidden = rect.bottom < 0 || rect.top > window.innerHeight;
    if (isHidden) {
      bar.classList.add('is-visible');
      bar.setAttribute('aria-hidden', 'false');
    } else {
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  // スティッキーボタン → メインフォームをクリック
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function() {
      var mainBtn = getMainBtn();
      if (mainBtn) mainBtn.click();
    });
  }

  // バリアント変更時に更新
  document.addEventListener('variant:changed', function(e) {
    var variant = e.detail && e.detail.variant;
    if (!variant) return;

    if (variantEl && variant.options) {
      variantEl.textContent = variant.options.join(' / ');
    }

    if (priceEl) {
      var html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += '<s>' + formatMoney(variant.compare_at_price) + '</s> ';
      }
      html += formatMoney(variant.price);
      priceEl.innerHTML = html;
    }

    if (stickyBtn) {
      stickyBtn.disabled = !variant.available;
      stickyBtn.textContent = variant.available ? 'カートに追加' : '売り切れ';
    }
  });

  // DOM読み込み完了後に初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBar);
  } else {
    initBar();
  }
})();
/* ===== /Sticky ATC Bar ===== */


/////////////////////////////////////////////// Powerful Form Builder ///////////////////////////////////////////////

/**
 * 交換・返品の選択に応じて項目を表示
 */
function toggleExchangeFields() {
    const form = document.querySelector('.globo-form-id-149569');
    if (!form) return;

    const exchange = form.querySelector('input[value="交換したい"]');
    const returned = form.querySelector('input[value="返品したい"]');

    const isExchange = exchange?.checked || false;
    const isReturn = returned?.checked || false;

    const file = form.querySelector('[data-element-id="file2-1"]');
    const schedule = form.querySelector('[data-element-id="text-4"]');

    if (file) {
        file.style.display = (isExchange || isReturn)
            ? 'block'
            : 'none';
    }

    if (schedule) {
        schedule.style.display = isExchange
            ? 'block'
            : 'none';
    }

    const fileInput = form.querySelector(
        '[data-element-id="file2-1"] input[type="file"]'
    );

    if (fileInput) {
        const required = isExchange || isReturn;

        fileInput.required = required;
        fileInput.setAttribute(
            'aria-required',
            required ? 'true' : 'false'
        );
    }

    switchParagraphByCheckbox();
}


/**
 * 交換・返品はどちらか一方のみ選択可能
 */
function limitExchangeCheckbox(currentCheckbox) {
    const form = document.querySelector('.globo-form-id-149569');
    if (!form) return;

    const checkboxes = form.querySelectorAll(
        '[data-element-id="checkbox-1"] input[type="checkbox"]'
    );

    if (currentCheckbox.checked) {
        checkboxes.forEach(function(checkbox) {
            if (checkbox !== currentCheckbox) {
                checkbox.checked = false;
            }
        });
    }

    toggleExchangeFields();
}


/**
 * paragraph-1の文章を区切り文字で分割し、
 * 交換・返品に応じて表示を切り替える
 */
function switchParagraphByCheckbox() {
    const form = document.querySelector('.globo-form-id-149569');
    if (!form) return;

    const exchange = form.querySelector('input[value="交換したい"]');
    const returned = form.querySelector('input[value="返品したい"]');

    const isExchange = exchange?.checked || false;
    const isReturn = returned?.checked || false;

    const paragraphWrap = form.querySelector(
        '[data-element-id="paragraph-1"]'
    );

    if (!paragraphWrap) return;

    const paragraph = paragraphWrap.querySelector('.globo-paragraph');
    if (!paragraph) return;

    const currentHtml = paragraph.innerHTML;

    /*
     * 区切り文字を含む元文章が表示された場合のみ保存
     */
    if (/%\s*--cut--\s*%/.test(currentHtml)) {
        paragraphWrap.dataset.fullParagraphHtml = currentHtml;
    }

    const originalHtml =
        paragraphWrap.dataset.fullParagraphHtml || currentHtml;

    const parts = originalHtml.split(/%\s*--cut--\s*%/);

    const exchangeHtml = parts[0]?.trim() || '';
    const returnHtml = parts[1]?.trim() || '';

    let nextHtml = null;

    if (isExchange) {
        nextHtml = exchangeHtml;
    } else if (isReturn) {
        nextHtml = returnHtml;
    }

    /*
     * 未選択の場合は非表示にするが、
     * 区切り文字が残ったままにならないよう中身も戻しておく
     */
    if (nextHtml === null) {
        if (/%\s*--cut--\s*%/.test(paragraph.innerHTML)) {
            paragraph.innerHTML = exchangeHtml;
        }

        paragraphWrap.style.display = 'none';
        return;
    }

    /*
     * 同じ内容を再代入するとMutationObserverが
     * 際限なく発火するため、変化がある場合のみ書き換える
     */
    if (paragraph.innerHTML !== nextHtml) {
        paragraph.innerHTML = nextHtml;
    }

    paragraphWrap.style.display = 'block';
}


/**
 * Powerful Form Builder側の再描画後にも表示を整える
 */
function updateExchangeFormWithDelay() {
    toggleExchangeFields();

    [0, 50, 200, 500, 1000, 2000, 3000].forEach(function(delay) {
        setTimeout(function() {
            toggleExchangeFields();
        }, delay);
    });
}


/**
 * Powerful Form BuilderによるDOMの再描画を監視
 */
let powerfulFormObserverStarted = false;

function observePowerfulForm() {
    if (powerfulFormObserverStarted) return;

    powerfulFormObserverStarted = true;

    let observerTimer = null;

    const observer = new MutationObserver(function(mutations) {
        const shouldUpdate = mutations.some(function(mutation) {
            const target = mutation.target;

            /*
             * characterDataの変化ではテキストノードが渡るため、
             * 親要素に読み替えてから判定する
             */
            const element = target.nodeType === Node.ELEMENT_NODE
                ? target
                : target.parentElement;

            if (element?.closest?.('[data-element-id="paragraph-1"]')) {
                return true;
            }

            /*
             * 送信完了後にフォームごと差し替えられる場合に対応
             */
            return Array.from(mutation.addedNodes).some(function(node) {
                if (node.nodeType !== Node.ELEMENT_NODE) return false;

                return node.matches?.('.globo-form-id-149569') ||
                    node.querySelector?.('.globo-form-id-149569');
            });
        });

        if (!shouldUpdate) return;

        clearTimeout(observerTimer);

        observerTimer = setTimeout(function() {
            toggleExchangeFields();
        }, 0);
    });

    /*
     * フォーム要素はPFBによって差し替えられるため、
     * body側を監視して再描画後も検知できるようにする
     */
    observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
    });
}


/**
 * 初期化
 */
function initPowerfulFormCustom() {
    document.addEventListener('change', function(e) {
        const target = e.target;

        if (
            target.matches(
                '.globo-form-id-149569 ' +
                '[data-element-id="checkbox-1"] ' +
                'input[type="checkbox"]'
            )
        ) {
            limitExchangeCheckbox(target);
            updateExchangeFormWithDelay();
            return;
        }

        if (target.closest('.globo-form-id-149569')) {
            updateExchangeFormWithDelay();
        }
    });

    /*
     * 送信時にも再処理
     */
    document.addEventListener('submit', function(e) {
        if (e.target.closest('.globo-form-id-149569')) {
            updateExchangeFormWithDelay();
        }
    }, true);

    /*
     * 送信ボタンを押した直後にも再処理
     */
    document.addEventListener('click', function(e) {
        const submitButton = e.target.closest(
            '.globo-form-id-149569 ' +
            'button[type="submit"], ' +
            '.globo-form-id-149569 ' +
            'input[type="submit"]'
        );

        if (submitButton) {
            updateExchangeFormWithDelay();
        }
    }, true);

    updateExchangeFormWithDelay();
    observePowerfulForm();
}


/**
 * フォームが遅れて読み込まれる場合にも対応
 */
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
        initPowerfulFormCustom();
    });
} else {
    initPowerfulFormCustom();
}


/**
 * アップロード画像を2MB以下に圧縮する
 */
async function compressImageUnder2MB(file) {
    const maxSize = 2 * 1024 * 1024; // 2MB

    // すでに2MB以下ならそのまま返す
    if (file.size <= maxSize) {
        return file;
    }

    if (!file.type.startsWith('image/')) {
        throw new Error('画像ファイルを選択してください。');
    }

    const image = await loadImageFromFile(file);

    let width = image.naturalWidth;
    let height = image.naturalHeight;

    // 最初に長辺を2000px以内へ縮小
    const maxDimension = 2000;

    if (width > maxDimension || height > maxDimension) {
        const scale = Math.min(
            maxDimension / width,
            maxDimension / height
        );

        width = Math.round(width * scale);
        height = Math.round(height * scale);
    }

    let quality = 0.9;
    let blob = null;

    // 容量が2MB以下になるまで画質を下げる
    for (let i = 0; i < 10; i++) {
        blob = await createCompressedBlob(
            image,
            width,
            height,
            quality
        );

        if (blob.size <= maxSize) {
            break;
        }

        quality -= 0.1;

        // 画質を下げても大きい場合は画像サイズも縮小
        if (quality < 0.5) {
            width = Math.round(width * 0.85);
            height = Math.round(height * 0.85);
            quality = 0.85;
        }
    }

    if (!blob || blob.size > maxSize) {
        throw new Error(
            '画像を2MB以下に圧縮できませんでした。別の画像をお試しください。'
        );
    }

    const originalName = file.name.replace(/\.[^.]+$/, '');

    return new File(
        [blob],
        originalName + '-compressed.jpg',
        {
            type: 'image/jpeg',
            lastModified: Date.now()
        }
    );
}


/**
 * ファイルから画像を読み込む
 */
function loadImageFromFile(file) {
    return new Promise(function(resolve, reject) {
        const image = new Image();
        const objectUrl = URL.createObjectURL(file);

        image.onload = function() {
            URL.revokeObjectURL(objectUrl);
            resolve(image);
        };

        image.onerror = function() {
            URL.revokeObjectURL(objectUrl);
            reject(
                new Error('画像の読み込みに失敗しました。')
            );
        };

        image.src = objectUrl;
    });
}


/**
 * CanvasでJPEGへ変換・圧縮する
 */
function createCompressedBlob(image, width, height, quality) {
    return new Promise(function(resolve, reject) {
        const canvas = document.createElement('canvas');

        canvas.width = width;
        canvas.height = height;

        const context = canvas.getContext('2d');

        if (!context) {
            reject(
                new Error('画像を圧縮できませんでした。')
            );
            return;
        }

        // PNGの透明部分が黒くならないよう白背景にする
        context.fillStyle = '#ffffff';
        context.fillRect(0, 0, width, height);

        context.drawImage(image, 0, 0, width, height);

        canvas.toBlob(
            function(blob) {
                if (blob) {
                    resolve(blob);
                } else {
                    reject(
                        new Error('画像の変換に失敗しました。')
                    );
                }
            },
            'image/jpeg',
            quality
        );
    });
}


/**
 * Powerful Form Builderの画像選択を監視
 */
document.addEventListener('change', async function(event) {
    const fileInput = event.target;

    if (!(fileInput instanceof HTMLInputElement)) {
        return;
    }

    if (
        !fileInput.matches(
            '.globo-form-id-149569 ' +
            '[data-element-id="file2-1"] ' +
            'input[type="file"]'
        )
    ) {
        return;
    }

    /*
     * 圧縮後に再発生させたchangeイベントの場合は、
     * Powerful Form Builderへそのまま渡す
     */
    if (fileInput.dataset.compressed === 'true') {
        delete fileInput.dataset.compressed;
        return;
    }

    const selectedFile = fileInput.files?.[0];

    if (!selectedFile) {
        return;
    }

    /*
     * Powerful Form Builderが圧縮前のファイルを
     * 読み取らないようにイベントを一時停止する
     */
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    try {
        const compressedFile =
            await compressImageUnder2MB(selectedFile);

        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(compressedFile);

        /*
         * inputのファイルを圧縮後の画像へ差し替える
         */
        fileInput.files = dataTransfer.files;

        const sizeMB =
            compressedFile.size / 1024 / 1024;

        console.log(
            '圧縮後の画像サイズ：' +
            sizeMB.toFixed(2) +
            'MB'
        );

        /*
         * 再帰処理を防ぐための目印
         */
        fileInput.dataset.compressed = 'true';

        /*
         * Powerful Form Builderに圧縮後のファイルを通知
         */
        fileInput.dispatchEvent(
            new Event('change', {
                bubbles: true
            })
        );

        fileInput.dispatchEvent(
            new Event('input', {
                bubbles: true
            })
        );

    } catch (error) {
        console.error(error);

        fileInput.value = '';

        alert(
            error instanceof Error
                ? error.message
                : '画像の圧縮に失敗しました。'
        );
    }
}, true); // captureフェーズで先に処理